export const globalLoadingConst = {
  connectionUpdate: 'connectionUpdate',
  connectionDetail: 'connectionDetail',
  listConnections: 'listConnections',
  dashboardInsights: 'dashboardInsights',
  exportPayment: 'exportPayment',
  createIssue: 'createIssue',
  updateIssue: 'updateIssue',
  listIssue: 'listIssue',
  updateComment: 'updateComment',
  apiKeys: 'apiKeys',
  apiKeysUpdate: 'apiKeysUpdate',
  saveConnectionForm: 'saveConnectionForm',
  webhookConfigurationForm: 'webhookConfigurationForm',
};
